import clsx from 'clsx';
import React, { useState } from 'react';

import desktopPhones from 'images/gift/desktop_phones.png';
import giftIcon from 'images/gift/giftbox_icon.svg';

import useCurrentUser from '@hooks/useCurrentUser';

import LandingGiftForm from './LandingGiftForm';
import PurchaseConfirmation from './PurchaseConfirmation';
import styles from './styles.module.scss';

const HeaderSection = ({ currentOffer }) => {
  const [currentFormStep, setCurrentFormStep] = useState<number>(0);
  const [numberOfGifts, setNumberOfGifts] = useState<number>(0);
  const { currentUser, isLoadingCurrentUser } = useCurrentUser(0);

  // FormStates
  // 1 => Purchase Confirmation
  // 0 => Form
  const GiftFormJSX = () =>
    currentFormStep == 1 ? (
      <PurchaseConfirmation
        setCurrentFormStep={setCurrentFormStep}
        numberOfPurchases={numberOfGifts}
      />
    ) : (
      <LandingGiftForm
        setCurrentFormStep={setCurrentFormStep}
        setNumberOfGifts={setNumberOfGifts}
        currentOffer={currentOffer}
      />
    );

  const FormJSX = () => {
    if (isLoadingCurrentUser) return null;

    return (
      <div className={styles.formContainer}>
        {currentUser?.settings_access_obj?.gift_sub_access ? (
          GiftFormJSX()
        ) : (
          <>
            <div className={styles.giftSectionHeader}>
              <div className={styles.settingsSectionHeadingText}>Gift Subscriptions</div>
              <div className={styles.settingsSectionHeadingLine}></div>
            </div>
            <div className={styles.giftSubHeader} id="GiftSubHeader">
              You need to be logged in with an active paid subscription to gift The Information to
              others.
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div className={styles.headerSectionContainer}>
      <div className={clsx(styles.headerWrapper, 'container')}>
        <div className="row">
          <div className={clsx(styles.headerContainer, 'col-sm-12 col-md-6')}>
            <div className={styles.giftHeader}>
              <div className={styles.header}>
                <div>Give</div>
                <span>The Information</span>
              </div>
              <div className={styles.subHeader}>
                From your account, you can purchase subscriptions for team members, family or
                friends.{' '}
              </div>
              <div className={styles.desktopPhoneContainer}>
                <img src={desktopPhones} className={styles.desktopPhones} alt="DesktopPhones" />
              </div>
            </div>
            <img src={giftIcon} className={styles.giftIcon} />
          </div>
          <div className={clsx('col-sm-12 col-md-6')}>{FormJSX()}</div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
